<template>
  <div class="">
    <div class="" v-if="loggedIn">
      <div>

        <!-- <img :src="require('../assets/images/mocha_egg.png')" /> -->
        <!-- <logo /> --> 
        <div class="justify-end flex">
          <button @click="newNews = !newNews" v-if="!newNews" class="bg-purple-400 hover:bg-purple-300 ounded-lg rounded-md sm:rounded-xl py-1 sm:py-2 px-2 sm:px-8 text-md sm:text-lg md:text-xl text-white font-body font-semibold text-center outline-none focus:outline-none focus:shadow-outline-purple">Create News</button>
          <button @click="newNews = !newNews" v-if="newNews" class="bg-gray-400 hover:bg-gray-300 ounded-lg rounded-md sm:rounded-xl py-1 sm:py-2 px-2 sm:px-8 text-md sm:text-lg md:text-xl text-white font-body font-semibold text-center outline-none focus:outline-none focus:shadow-outline-purple">Close</button>
        </div>     
        
        <div v-if="loggedIn && newNews">
          <div class="px-2 sm:px-4 pb-4">
            <div class="mt-4 sm:mb-2" >
              <div class="pb-3 sm:pb-5">
                <div class="px-3 sm:px-5 md:px-10 pt-3 sm:pt-5 md:pt-10 pb-2 shadow-inner bg-white rounded-xl border-4 border-purple-300">
                  <TextEditor ref="postref" :editable="true" @commentJSON="postJSON" />
                </div>
                <div v-if="postError != null" class="pt-3 px-3 text-red-500">
                  {{ postError }}
                </div>
              </div>
              <div class="flex justify-end">
                <div>
                  <div class="w-full flex justify-start sm:pt-2"><button @click="newPost" class="bg-purple-400 hover:bg-purple-300 ounded-lg rounded-md sm:rounded-xl py-1 sm:py-2 px-2 sm:px-8 text-md sm:text-lg md:text-xl text-white font-body font-semibold text-center outline-none focus:outline-none focus:shadow-outline-purple">Submit</button></div>
                </div>
              </div>
            </div>
            <!-- <div class="pt-3 sm:pt-5 sm:px-3 sm:pb-3 text-2xs sm:text-xs text-gray-600 font-body font-semibold">{{ format_date(post.created) }} - {{ format_since(post.created) }}<span class="ml-1 sm:ml-2 text-purple-700 hover:text-purple-300 cursor-pointer">| {{ post.user.id == usercode ? 'EDIT' : 'QUOTE' }}</span></div> -->
          </div>
        </div>
        
        <div class="py-4" v-for="(post, index) in news" :key="index">
          <TextEditor :editable="false" :json="post.content" />
          <div class="pt-2 pb-4 text-purple-200 text-sm font-semibold">
            {{ format_date(post.created) }} - {{ format_since(post.created) }}
          </div>
        </div>
      </div>
    </div>
    <div class="h-full" v-if="!loggedIn">
      <div class="relative overflow-hidden content-center bg-white">
        <picture>
          <source srcset="../assets/images/landingpage2.webp" type="image/webp">
          <source srcset="../assets/images/landingpage2.png" type="image/png">
          <img class="absolute object-cover h-full sm:w-full sm:h-auto z-10" src="../assets/images/landing.jpg" />
        </picture>
        <div class="pt-24 pb-12 px-6 md:pt-36 md:pb-24 md:px-12 lg:pt-64 lg:pb-32 lg:px-24 z-20 flex justify-center">
          <div class="pt-12 md:pt-24 lg:pt-36 z-30 ">
            <div class="bg-gray-100 shadow-sm rounded-xl p-5 border-4 bg-opacity-75 backdrop-blurless border-gray-300">
              <div class="p-3 md:p-5">
                <div class="text-center text-2xl md:text-4xl font-sans text-gray-700">
                  {{landingHeading}}
                </div>
                <div class="text-center font-body text-gray-600">
                  {{landingDescription}}
                </div>
              </div>
              <div class="hidden sm:flex mt-2 rounded-xl shadow-sm">
                <input v-model="emailAddress" class="p-3 bg-gray-100 overflow-visible w-full placeholder-gray-400 outline-none focus:outline-none focus:border-purple-300 focus:shadow-outline-purple rounded-l-xl shadow-inner border font-body text-black" placeholder="Email Address" />
                <button @click="play" class="anim w-64 bg-gradient-purple bg-2nd-half hover:bg-1st-half text-lg text-white font-body font-semibold rounded-r-xl outline-none focus:outline-none focus:shadow-outline-purple">
                  {{buttonText}}
                </button>
              </div>
              <div class="block sm:hidden mt-2">
                <div class="rounded-xl shadow-sm">
                  <input v-model="emailAddress" type="email" class="p-3 bg-gray-100 overflow-visible w-full placeholder-gray-400 outline-none focus:outline-none focus:border-purple-300 focus:shadow-outline-purple rounded-xl shadow-inner border font-body text-black" placeholder="Email Address" />
                </div>
                <div class="w-full flex justify-center">
                  <button @click="play" class="anim w-full py-3 px-12 mt-3 bg-gradient-purple bg-2nd-half text-lg text-white font-body font-semibold rounded-xl outline-none focus:outline-none focus:shadow-outline-purple">
                    {{buttonText}}
                  </button>
                </div>            
              </div>
            </div>
            <div v-if="error != '' || success != ''" class="flex mt-4 backdrop-blurless rounded-xl shadow-sm border-4 border-gray-300">
              <div class="p-2 bg-white rounded-lg opacity-75 w-full text-center font-body">
                <div class="text-red-500" v-if="error != ''">
                  {{error}}
                </div>
                <div class="text-green-500" v-if="success != ''">
                  {{success}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-3 md:pt-10 bg-white">

      </div>
      <div class="pb-6 md:pb-10 bg-white border-b-4 border-purple-300">
        <a href="https://twitter.com/Ilmeria13" class="flex justify-center" target="_blank">
          <div class="text-sm md:text-base font-body content-center hover:underline pt-2">
            Follow @Ilmeria13 for the latest updates
          </div>
          <div class="w-10 p-1 text-blue-500 fill-current">
            <svg version="1.1" id="White" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 400 400" style="enable-background:new 0 0 400 400;" xml:space="preserve">
              <path class="st0" d="M400,200c0,110.5-89.5,200-200,200S0,310.5,0,200S89.5,0,200,0S400,89.5,400,200z M163.4,305.5
                c88.7,0,137.2-73.5,137.2-137.2c0-2.1,0-4.2-0.1-6.2c9.4-6.8,17.6-15.3,24.1-25c-8.6,3.8-17.9,6.4-27.7,7.6
                c10-6,17.6-15.4,21.2-26.7c-9.3,5.5-19.6,9.5-30.6,11.7c-8.8-9.4-21.3-15.2-35.2-15.2c-26.6,0-48.2,21.6-48.2,48.2
                c0,3.8,0.4,7.5,1.3,11c-40.1-2-75.6-21.2-99.4-50.4c-4.1,7.1-6.5,15.4-6.5,24.2c0,16.7,8.5,31.5,21.5,40.1c-7.9-0.2-15.3-2.4-21.8-6
                c0,0.2,0,0.4,0,0.6c0,23.4,16.6,42.8,38.7,47.3c-4,1.1-8.3,1.7-12.7,1.7c-3.1,0-6.1-0.3-9.1-0.9c6.1,19.2,23.9,33.1,45,33.5
                c-16.5,12.9-37.3,20.6-59.9,20.6c-3.9,0-7.7-0.2-11.5-0.7C110.8,297.5,136.2,305.5,163.4,305.5"/>
            </svg>
          </div>
        </a>
      </div>
      
      <div class="container pt-6 md:pt-24 max-w-6xl flex mx-auto flex-wrap pb-10 px-2">
          <div class="mb-10 p-6 sm:p-10 md:p-20 shadow-inner bg-white rounded-xl border-4 border-purple-300 w-full" v-for="(post, index) in news" :key="index">
            <TextEditor :editable="false" :json="post.content" />
            <div class="pt-3 sm:pt-6 md:pt-10 text-purple-200 text-xs sm:text-sm font-semibold">
              {{ format_date(post.created) }} - {{ format_since(post.created) }}
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import DevPost from "@/components/DevPost.vue";
import { mapState } from 'vuex'

import gql from "graphql-tag";
import Spinner from "@/components/Spinner.vue";
import TextEditor from '../components/TextEditor.vue';
import moment from "moment";

const GET_NEWS = gql`
  query GetNews {
    news: catlia_news(order_by: {created: desc}) {
      content
      created
    }
  }`;

export default {
  name: "home",
  apollo: {
    news: {
      query: GET_NEWS,
      variables (){
        return {
        }
      },
      //pollInterval: 10000,
    },
  },
  components: {
    DevPost,
    Spinner,
    TextEditor
  },
  computed: mapState(['loggedIn', 'cookie', 'usercode']),
  data(){
    return {
      //cookie: this.$store.state.cookie,
      //loggedIn: this.$store.state.loggedIn,
      landingHeading: "COMING SOON™",
      landingDescription: "Subscribe to be notified on launch!",
      emailAddress: "",
      special: null,
      buttonText: process.env.NODE_ENV == "development" ? 'PLAY NOW' : 'SUBSCRIBE',
      error: '',
      success: '',
      dev: process.env.NODE_ENV == "development",
      firstPost: "[{\"type\":\"text\",\"value\":\"Update: Meika, the Shopkeeper\",\"style\":\"font-body text-lg md:text-xl\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"Left to your own devices, you decide to explore the castle. All sorts of beings pass you by - some fierce and thunderous, others extremely delicate and carefully flitting through the crowd. You're starting to feel a little faint when someone reaches out and steadies you with a very fluffy paw.\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"\\\"Hi! Are you alright there?\\\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"You look down. Err. Up? One of those. A small, shaggy dog blinks back at you.\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"Before you can respond, she continues. \\\"Oh! You must be new to these parts. My store's just around the corner if you need to find a spot to yourself.\\\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"She zooms off, deftly navigating the crowd. You struggle not to lose sight of her. It turns out that \\\"just around the corner\\\" really meant \\\"about five thousand steps away\\\".\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"As you make a mental note to never trust anyone's measure of time or space ever again, the dog stops in front of an overflowing stall. Meika's Market is emblazoned in fancy gold lettering on a red banner.\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"As you approach, Meika - presumably - introduces herself. \\\"Welcome! I know you're just about to ask, and I meant to say so earlier, but...I'm Meika, owner of the best market in Catlia! Please, make yourself at home. I can show you around later, if you'd like.\\\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"img\",\"value\":\"/img/meika.75d898da.png\",\"style\":\"mx-auto\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"- Posted July 9th 2020\",\"style\":\"font-body text-sm md:text-base\"}]",
      secondPost: "[{\"type\":\"text\",\"value\":\"Hey! Welcome to the development blog for Catlia, an upcoming pet site with a fantasy theme and a variety of species to collect.\",\"style\":\"font-body text-lg md:text-xl\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-lg md:text-xl\"},{\"type\":\"text\",\"value\":\"In a parallel universe, a magical cat monarchy has been established on the moon. Without humans catering to their every whim, the cats were in grave peril - until they discovered they could harness the power of the moon to perform magic. With their newfound abilities, they have been slowly catnapping different animal species from Earth over the years, but haven’t collected enough mana to transport humans yet - it is suspected that humans’ complex thoughts make them more difficult to move.\",\"style\":\"font-body text-base md:text-lg\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-lg md:text-xl\"},{\"type\":\"text\",\"value\":\"There’s plenty to do in the meantime, at least! Your life as an ordinary cat on the outskirts of Catlia has taken a strange turn after you decide to finally visit the kingdom. After a brush with death (well, after tripping and landing in a puddle), you find that your rescuer is none other than Mocha, the kingdom’s prince.\",\"style\":\"font-body text-base md:text-lg\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-base md:text-lg\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-base md:text-lg\"},{\"type\":\"img\",\"value\":\"/img/princemocha.4b7aaa9b.png\",\"style\":\"mx-auto pr-5\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-lg md:text-xl\"},{\"type\":\"text\",\"value\":\"While you dry off in the sunshine, Mocha chatters excitedly about what Catlia has to offer:\",\"style\":\"font-body text-base md:text-lg\"},{\"type\":\"text\",\"value\":\"    • Pets which can be dressed up\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"    • Discovering new items/pets through alchemy\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"    • Magical potions that may attract rare species\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"    • Quests with special rewards\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"    • Daily events and rewards\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"    • Random chance shops/Shops with set stock\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-lg md:text-xl\"},{\"type\":\"text\",\"value\":\"…and probably other things, but alas. Mocha regretfully explains that he must attend to his royal duties, and wishes you luck.\",\"style\":\"font-body text-base md:text-lg\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-lg md:text-xl\"},{\"type\":\"text\",\"value\":\"If you’d like to receive an email once the site’s released, please feel free to subscribe.\",\"style\":\"font-body text-base md:text-lg\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-base md:text-lg\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-base md:text-lg\"},{\"type\":\"img\",\"value\":\"/img/3kittens.6790ba53.jpg\",\"style\":\"\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"\",\"style\":\"font-body text-sm md:text-base\"},{\"type\":\"text\",\"value\":\"- Posted July 2nd 2020\",\"style\":\"font-body text-sm md:text-base\"}]",
      //buttonText: true ? 'PLAY NOW' : 'SUBSCRIBE',
      news: [],
      newNews: false,
      postContent: null,
      postError: null
    }
  },
  mounted(){
    this.special = "ajghgisg@45h"
  },
  methods: {
    postJSON(json){
      this.postContent = json
    },
    format_date(value){
      if (value) {
        return moment(value).format('DD MMM YYYY hh:mm A').toUpperCase()
      }
    },
    format_since(value){
      if (value) {
        return moment(value).fromNow().toUpperCase()
      }
    },
    play(){
      if(process.env.NODE_ENV == 'production'){
        this.$store.commit('signUpEmail', this.emailAddress)
        this.axios.post('https://subscribe.catlia.net/', {
        //this.axios.post('https://fragrant-dream-42b3.catliadotnet.workers.dev/', {
            "email": this.emailAddress,
            "special": this.special,
          }).then((data) => {
            this.error = ''
            this.success = data.data
          }).catch((err) => {
            this.success = ''
            if( err.response ){
              this.error = err.response.data
            }else {
              this.error = err
            }
          })
        return
      }
      
      this.$store.commit('signUpEmail', this.emailAddress)
      this.$router.push({
        path: '/signup',

      })
    },
    newPost(){
      console.log("Creating new news post! : With user "+this.usercode)
      
      this.$apollo.mutate({
        mutation: gql`
          mutation ($user_id: bigint, $content: jsonb){
            insert_catlia_news_one(object: {content: $content, user_id: $user_id}) {
              id
            }
          }`,
          variables: {
            content: this.postContent,
            user_id: this.usercode
          },
      }).then((data) => {
        this.postError = null
        this.postContent = null
        this.$refs.postref.clear()
        this.$apollo.queries.news.refetch()
        
        console.log(data)
      }).catch((err) => {
        
        if( err.graphQLErrors && err.graphQLErrors.length > 0 ){
          if(err.graphQLErrors[0].message.includes("lencheck")){
            this.postError = 'Error post is too large.'
          } else {
            this.postError = 'Error failed to submit new post.'
          }

          console.log(err.graphQLErrors)
        } else if( err.networkError ) {
          
          this.postError = 'Error unable to connect to server.'
          console.log(err.networkError)
        } else {
          
          this.postError = 'Error failed to submit new post.'
          console.log(err)
        }
      })
    }
  }
};
</script>
